export default __webpack_public_path__ + "assets/music.e859c7a8.svg";